import { z } from 'zod';

/** Durable provenance belongs to Hector, independently of the mail provider or host property bag. */
export const MailboxFilingProviderSchema = z.enum(['gmail', 'microsoft']);
export type MailboxFilingProvider = z.infer<typeof MailboxFilingProviderSchema>;
export const MailboxFilingWriteSchema = z.object({ caseId: z.string().uuid(), documentId: z.string().uuid() }).strict();
export const MailboxFilingMarkSchema = MailboxFilingWriteSchema.extend({ savedAt: z.string().datetime() });
export const MailboxFilingsResponseSchema = z.object({ marks: z.array(MailboxFilingMarkSchema) }).strict();
export type MailboxFilingMark = z.infer<typeof MailboxFilingMarkSchema>;
/** Graph identifiers are opaque; encode them as one URL component, never parse them as Gmail IDs. */
export const MailboxFilingMessageIdSchema = z.string().min(1).max(4096).regex(/^[^\s\u0000-\u001f\u007f]+$/);
